import React from "react";

import { observer } from "mobx-react";

import { FiscalizationItem } from "../BetDetailsModalFiscalization";
import { useTranslation } from "react-i18next";

export const TransactionNumber = observer(function TransactionNumber(props: {
	firstFinishedTransaction: FiscalizationItem;
}) {
	const { t } = useTranslation("mybets");

	const { firstFinishedTransaction } = props;

	return (
		<div className="bet__details__row table--bet__fiscalization__row">
			<div className="bet__details__col table--bet__fiscalization__data">
				{t("mybets:ITEM.ADDITIONAL_TRANSACTION_NUMBER")}:
			</div>
			<div className="bet__details__col table--bet__fiscalization__data">
				{firstFinishedTransaction.transactionNumber}
			</div>
		</div>
	);
});
